import { Mui } from '@osu/react-ui';
import Chip from './scoresChip';
import useStyles from '../../dd-styles';

const ACTScores = (props) => {
  const { studentData } = props;
  const classes = useStyles();

  if (!(studentData?.data?.scores?.act?.length > 0)) {
      return (
        <>
          <Mui.Typography tabindex="0" aria-label='A C T' component="h3" variant="h6" key={1}>
            ACT
          </Mui.Typography>
          <Mui.Typography style={{marginLeft: '.5rem'}}>No test information available</Mui.Typography>
        </>
      )   
    }
  
  return (
    <>
      <Mui.Typography aria-label='A C T' tabindex="0" component="h3" variant="h6">
        ACT
      </Mui.Typography>
      {studentData?.data?.scores?.act?.length > 0 ? (
        <>
          <Mui.Box style={{ display: 'flex', flexWrap: 'wrap' }}>
            {studentData?.data?.scores?.act?.map?.((item, index) => (
              <dl title="A C T" key={index} className={classes.dl}>
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'Date'}
                    childLabel={item.map((item) => item.date ?? "N/A")}
                  />
                </dd>
                {<dd tabindex="0" className={[classes.dd, classes.ddtestid].join(" ")}><Chip childLabel={item.map(item => item?.testId)} /></dd> }
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'Composite'}
                    childLabel={item.map((item) => item.composite ?? "N/A")}
                  />
                </dd>
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'Math'}
                    childLabel={item.map((item) => item.math ?? "N/A")}
                  />
                </dd>
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'Reading'}
                    childLabel={item.map((item) => item.reading ?? "N/A")}
                  />
                </dd>
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'English'}
                    childLabel={item.map((item) => item.english ?? "N/A")}
                  />
                </dd>
                <dd tabindex="0" className={classes.dd}>
                  <Chip
                    label={'Science'}
                    childLabel={item.map((item) => item.science ?? "N/A")}
                  />
                </dd>
                <Mui.Divider />
              </dl>
            ))}
          </Mui.Box>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default ACTScores;
